export const urlParamUserId = "userId";
export const urlParamPrepId = "prepId";
